import { ReactComponent as ABW } from './ABW.svg';
import { ReactComponent as AFG } from './AFG.svg';
import { ReactComponent as AGO } from './AGO.svg';
import { ReactComponent as AIA } from './AIA.svg';
import { ReactComponent as ALA } from './ALA.svg';
import { ReactComponent as ALB } from './ALB.svg';
import { ReactComponent as AND } from './AND.svg';
import { ReactComponent as ARE } from './ARE.svg';
import { ReactComponent as ARG } from './ARG.svg';
import { ReactComponent as ARM } from './ARM.svg';
import { ReactComponent as ASM } from './ASM.svg';
import { ReactComponent as ATA } from './ATA.svg';
import { ReactComponent as ATG } from './ATG.svg';
import { ReactComponent as AUD } from './AUD.svg';
import { ReactComponent as AUS } from './AUS.svg';
import { ReactComponent as AUT } from './AUT.svg';
import { ReactComponent as AZE } from './AZE.svg';
import { ReactComponent as BDI } from './BDI.svg';
import { ReactComponent as BEL } from './BEL.svg';
import { ReactComponent as BEN } from './BEN.svg';
import { ReactComponent as BFA } from './BFA.svg';
import { ReactComponent as BGD } from './BGD.svg';
import { ReactComponent as BGR } from './BGR.svg';
import { ReactComponent as BHR } from './BHR.svg';
import { ReactComponent as BHS } from './BHS.svg';
import { ReactComponent as BIH } from './BIH.svg';
import { ReactComponent as BLM } from './BLM.svg';
import { ReactComponent as BLR } from './BLR.svg';
import { ReactComponent as BLZ } from './BLZ.svg';
import { ReactComponent as BMU } from './BMU.svg';
import { ReactComponent as BOL } from './BOL.svg';
import { ReactComponent as BRA } from './BRA.svg';
import { ReactComponent as BRB } from './BRB.svg';
import { ReactComponent as BRN } from './BRN.svg';
import { ReactComponent as BTN } from './BTN.svg';
import { ReactComponent as BVT } from './BVT.svg';
import { ReactComponent as BWA } from './BWA.svg';
import { ReactComponent as CAF } from './CAF.svg';
import { ReactComponent as CAN } from './CAN.svg';
import { ReactComponent as CCK } from './CCK.svg';
import { ReactComponent as CHE } from './CHE.svg';
import { ReactComponent as CHL } from './CHL.svg';
import { ReactComponent as CHN } from './CHN.svg';
import { ReactComponent as CIV } from './CIV.svg';
import { ReactComponent as CMR } from './CMR.svg';
import { ReactComponent as COD } from './COD.svg';
import { ReactComponent as COG } from './COG.svg';
import { ReactComponent as COK } from './COK.svg';
import { ReactComponent as COL } from './COL.svg';
import { ReactComponent as COM } from './COM.svg';
import { ReactComponent as CPV } from './CPV.svg';
import { ReactComponent as CRI } from './CRI.svg';
import { ReactComponent as CUB } from './CUB.svg';
import { ReactComponent as CXR } from './CXR.svg';
import { ReactComponent as CYM } from './CYM.svg';
import { ReactComponent as CYP } from './CYP.svg';
import { ReactComponent as CZE } from './CZE.svg';
import { ReactComponent as DEU } from './DEU.svg';
import { ReactComponent as DJI } from './DJI.svg';
import { ReactComponent as DMA } from './DMA.svg';
import { ReactComponent as DNK } from './DNK.svg';
import { ReactComponent as DOM } from './DOM.svg';
import { ReactComponent as DZA } from './DZA.svg';
import { ReactComponent as ECU } from './ECU.svg';
import { ReactComponent as EGY } from './EGY.svg';
import { ReactComponent as ERI } from './ERI.svg';
import { ReactComponent as ESH } from './ESH.svg';
import { ReactComponent as ESP } from './ESP.svg';
import { ReactComponent as EST } from './EST.svg';
import { ReactComponent as ETH } from './ETH.svg';
import { ReactComponent as EUR } from './EUR.svg';
import { ReactComponent as FIN } from './FIN.svg';
import { ReactComponent as FJI } from './FJI.svg';
import { ReactComponent as FLK } from './FLK.svg';
import { ReactComponent as FRA } from './FRA.svg';
import { ReactComponent as FRO } from './FRO.svg';
import { ReactComponent as FSM } from './FSM.svg';
import { ReactComponent as GAB } from './GAB.svg';
import { ReactComponent as GBR } from './GBR.svg';
import { ReactComponent as GEO } from './GEO.svg';
import { ReactComponent as GGY } from './GGY.svg';
import { ReactComponent as GHA } from './GHA.svg';
import { ReactComponent as GIB } from './GIB.svg';
import { ReactComponent as GIN } from './GIN.svg';
import { ReactComponent as GLP } from './GLP.svg';
import { ReactComponent as GMB } from './GMB.svg';
import { ReactComponent as GNB } from './GNB.svg';
import { ReactComponent as GNQ } from './GNQ.svg';
import { ReactComponent as GRC } from './GRC.svg';
import { ReactComponent as GRD } from './GRD.svg';
import { ReactComponent as GRL } from './GRL.svg';
import { ReactComponent as GTM } from './GTM.svg';
import { ReactComponent as GUF } from './GUF.svg';
import { ReactComponent as GUM } from './GUM.svg';
import { ReactComponent as GUY } from './GUY.svg';
import { ReactComponent as HKG } from './HKG.svg';
import { ReactComponent as HMD } from './HMD.svg';
import { ReactComponent as HND } from './HND.svg';
import { ReactComponent as HRV } from './HRV.svg';
import { ReactComponent as HTI } from './HTI.svg';
import { ReactComponent as HUN } from './HUN.svg';
import { ReactComponent as IDN } from './IDN.svg';
import { ReactComponent as IMN } from './IMN.svg';
import { ReactComponent as IND } from './IND.svg';
import { ReactComponent as IOT } from './IOT.svg';
import { ReactComponent as IRL } from './IRL.svg';
import { ReactComponent as IRN } from './IRN.svg';
import { ReactComponent as IRQ } from './IRQ.svg';
import { ReactComponent as ISL } from './ISL.svg';
import { ReactComponent as ISR } from './ISR.svg';
import { ReactComponent as ITA } from './ITA.svg';
import { ReactComponent as JAM } from './JAM.svg';
import { ReactComponent as JEY } from './JEY.svg';
import { ReactComponent as JOR } from './JOR.svg';
import { ReactComponent as JPN } from './JPN.svg';
import { ReactComponent as KAZ } from './KAZ.svg';
import { ReactComponent as KEN } from './KEN.svg';
import { ReactComponent as KGZ } from './KGZ.svg';
import { ReactComponent as KHM } from './KHM.svg';
import { ReactComponent as KIR } from './KIR.svg';
import { ReactComponent as KNA } from './KNA.svg';
import { ReactComponent as KOR } from './KOR.svg';
import { ReactComponent as KWT } from './KWT.svg';
import { ReactComponent as LAO } from './LAO.svg';
import { ReactComponent as LBN } from './LBN.svg';
import { ReactComponent as LBR } from './LBR.svg';
import { ReactComponent as LBY } from './LBY.svg';
import { ReactComponent as LCA } from './LCA.svg';
import { ReactComponent as LIE } from './LIE.svg';
import { ReactComponent as LKA } from './LKA.svg';
import { ReactComponent as LSO } from './LSO.svg';
import { ReactComponent as LTU } from './LTU.svg';
import { ReactComponent as LUX } from './LUX.svg';
import { ReactComponent as LVA } from './LVA.svg';
import { ReactComponent as MAC } from './MAC.svg';
import { ReactComponent as MAF } from './MAF.svg';
import { ReactComponent as MAR } from './MAR.svg';
import { ReactComponent as MCO } from './MCO.svg';
import { ReactComponent as MDA } from './MDA.svg';
import { ReactComponent as MDG } from './MDG.svg';
import { ReactComponent as MDV } from './MDV.svg';
import { ReactComponent as MEX } from './MEX.svg';
import { ReactComponent as MHL } from './MHL.svg';
import { ReactComponent as MKD } from './MKD.svg';
import { ReactComponent as MLI } from './MLI.svg';
import { ReactComponent as MLT } from './MLT.svg';
import { ReactComponent as MMR } from './MMR.svg';
import { ReactComponent as MNE } from './MNE.svg';
import { ReactComponent as MNG } from './MNG.svg';
import { ReactComponent as MNP } from './MNP.svg';
import { ReactComponent as MOZ } from './MOZ.svg';
import { ReactComponent as MRT } from './MRT.svg';
import { ReactComponent as MSR } from './MSR.svg';
import { ReactComponent as MTQ } from './MTQ.svg';
import { ReactComponent as MUS } from './MUS.svg';
import { ReactComponent as MWI } from './MWI.svg';
import { ReactComponent as MYS } from './MYS.svg';
import { ReactComponent as MYT } from './MYT.svg';
import { ReactComponent as NAM } from './NAM.svg';
import { ReactComponent as NCL } from './NCL.svg';
import { ReactComponent as NER } from './NER.svg';
import { ReactComponent as NFK } from './NFK.svg';
import { ReactComponent as NGA } from './NGA.svg';
import { ReactComponent as NIC } from './NIC.svg';
import { ReactComponent as NIU } from './NIU.svg';
import { ReactComponent as NLD } from './NLD.svg';
import { ReactComponent as NOR } from './NOR.svg';
import { ReactComponent as NPL } from './NPL.svg';
import { ReactComponent as NRU } from './NRU.svg';
import { ReactComponent as NZL } from './NZL.svg';
import { ReactComponent as OMN } from './OMN.svg';
import { ReactComponent as PAK } from './PAK.svg';
import { ReactComponent as PAN } from './PAN.svg';
import { ReactComponent as PCN } from './PCN.svg';
import { ReactComponent as PER } from './PER.svg';
import { ReactComponent as PHL } from './PHL.svg';
import { ReactComponent as PLW } from './PLW.svg';
import { ReactComponent as PNG } from './PNG.svg';
import { ReactComponent as POL } from './POL.svg';
import { ReactComponent as PRI } from './PRI.svg';
import { ReactComponent as PRK } from './PRK.svg';
import { ReactComponent as PRT } from './PRT.svg';
import { ReactComponent as PRY } from './PRY.svg';
import { ReactComponent as PSE } from './PSE.svg';
import { ReactComponent as PYF } from './PYF.svg';
import { ReactComponent as QAT } from './QAT.svg';
import { ReactComponent as REU } from './REU.svg';
import { ReactComponent as ROU } from './ROU.svg';
import { ReactComponent as RUS } from './RUS.svg';
import { ReactComponent as RWA } from './RWA.svg';
import { ReactComponent as SAU } from './SAU.svg';
import { ReactComponent as SDN } from './SDN.svg';
import { ReactComponent as SEN } from './SEN.svg';
import { ReactComponent as SGP } from './SGP.svg';
import { ReactComponent as SGS } from './SGS.svg';
import { ReactComponent as SHN } from './SHN.svg';
import { ReactComponent as SJM } from './SJM.svg';
import { ReactComponent as SLB } from './SLB.svg';
import { ReactComponent as SLE } from './SLE.svg';
import { ReactComponent as SLV } from './SLV.svg';
import { ReactComponent as SMR } from './SMR.svg';
import { ReactComponent as SOM } from './SOM.svg';
import { ReactComponent as SPM } from './SPM.svg';
import { ReactComponent as SRB } from './SRB.svg';
import { ReactComponent as SSD } from './SSD.svg';
import { ReactComponent as STP } from './STP.svg';
import { ReactComponent as SUR } from './SUR.svg';
import { ReactComponent as SVK } from './SVK.svg';
import { ReactComponent as SVN } from './SVN.svg';
import { ReactComponent as SWE } from './SWE.svg';
import { ReactComponent as SWZ } from './SWZ.svg';
import { ReactComponent as SYC } from './SYC.svg';
import { ReactComponent as SYR } from './SYR.svg';
import { ReactComponent as TCA } from './TCA.svg';
import { ReactComponent as TCD } from './TCD.svg';
import { ReactComponent as TGO } from './TGO.svg';
import { ReactComponent as THA } from './THA.svg';
import { ReactComponent as TJK } from './TJK.svg';
import { ReactComponent as TKL } from './TKL.svg';
import { ReactComponent as TKM } from './TKM.svg';
import { ReactComponent as TLS } from './TLS.svg';
import { ReactComponent as TON } from './TON.svg';
import { ReactComponent as TTO } from './TTO.svg';
import { ReactComponent as TUN } from './TUN.svg';
import { ReactComponent as TUR } from './TUR.svg';
import { ReactComponent as TUV } from './TUV.svg';
import { ReactComponent as TWN } from './TWN.svg';
import { ReactComponent as TZA } from './TZA.svg';
import { ReactComponent as UGA } from './UGA.svg';
import { ReactComponent as UKR } from './UKR.svg';
import { ReactComponent as URY } from './URY.svg';
import { ReactComponent as USA } from './USA.svg';
import { ReactComponent as UZB } from './UZB.svg';
import { ReactComponent as VAT } from './VAT.svg';
import { ReactComponent as VCT } from './VCT.svg';
import { ReactComponent as VEN } from './VEN.svg';
import { ReactComponent as VGB } from './VGB.svg';
import { ReactComponent as VIR } from './VIR.svg';
import { ReactComponent as VNM } from './VNM.svg';
import { ReactComponent as VUT } from './VUT.svg';
import { ReactComponent as WLF } from './WLF.svg';
import { ReactComponent as WSM } from './WSM.svg';
import { ReactComponent as XKX } from './XKX.svg';
import { ReactComponent as YEM } from './YEM.svg';
import { ReactComponent as ZAF } from './ZAF.svg';
import { ReactComponent as ZMB } from './ZMB.svg';
import { ReactComponent as ZWE } from './ZWE.svg';

export const ABWFlag = ABW;
export const AFGFlag = AFG;
export const AGOFlag = AGO;
export const AIAFlag = AIA;
export const ALAFlag = ALA;
export const ALBFlag = ALB;
export const ANDFlag = AND;
export const AREFlag = ARE;
export const ARGFlag = ARG;
export const ARMFlag = ARM;
export const ASMFlag = ASM;
export const ATAFlag = ATA;
export const ATGFlag = ATG;
export const AUDFlag = AUD;
export const AUSFlag = AUS;
export const AUTFlag = AUT;
export const AZEFlag = AZE;
export const BDIFlag = BDI;
export const BELFlag = BEL;
export const BENFlag = BEN;
export const BFAFlag = BFA;
export const BGDFlag = BGD;
export const BGRFlag = BGR;
export const BHRFlag = BHR;
export const BHSFlag = BHS;
export const BIHFlag = BIH;
export const BLMFlag = BLM;
export const BLRFlag = BLR;
export const BLZFlag = BLZ;
export const BMUFlag = BMU;
export const BOLFlag = BOL;
export const BRAFlag = BRA;
export const BRBFlag = BRB;
export const BRNFlag = BRN;
export const BTNFlag = BTN;
export const BVTFlag = BVT;
export const BWAFlag = BWA;
export const CAFFlag = CAF;
export const CANFlag = CAN;
export const CCKFlag = CCK;
export const CHEFlag = CHE;
export const CHLFlag = CHL;
export const CHNFlag = CHN;
export const CIVFlag = CIV;
export const CMRFlag = CMR;
export const CODFlag = COD;
export const COGFlag = COG;
export const COKFlag = COK;
export const COLFlag = COL;
export const COMFlag = COM;
export const CPVFlag = CPV;
export const CRIFlag = CRI;
export const CUBFlag = CUB;
export const CXRFlag = CXR;
export const CYMFlag = CYM;
export const CYPFlag = CYP;
export const CZEFlag = CZE;
export const DEUFlag = DEU;
export const DJIFlag = DJI;
export const DMAFlag = DMA;
export const DNKFlag = DNK;
export const DOMFlag = DOM;
export const DZAFlag = DZA;
export const ECUFlag = ECU;
export const EGYFlag = EGY;
export const ERIFlag = ERI;
export const ESHFlag = ESH;
export const ESPFlag = ESP;
export const ESTFlag = EST;
export const ETHFlag = ETH;
export const EURFlag = EUR;
export const FINFlag = FIN;
export const FJIFlag = FJI;
export const FLKFlag = FLK;
export const FRAFlag = FRA;
export const FROFlag = FRO;
export const FSMFlag = FSM;
export const GABFlag = GAB;
export const GBRFlag = GBR;
export const GEOFlag = GEO;
export const GGYFlag = GGY;
export const GHAFlag = GHA;
export const GIBFlag = GIB;
export const GINFlag = GIN;
export const GLPFlag = GLP;
export const GMBFlag = GMB;
export const GNBFlag = GNB;
export const GNQFlag = GNQ;
export const GRCFlag = GRC;
export const GRDFlag = GRD;
export const GRLFlag = GRL;
export const GTMFlag = GTM;
export const GUFFlag = GUF;
export const GUMFlag = GUM;
export const GUYFlag = GUY;
export const HKGFlag = HKG;
export const HMDFlag = HMD;
export const HNDFlag = HND;
export const HRVFlag = HRV;
export const HTIFlag = HTI;
export const HUNFlag = HUN;
export const IDNFlag = IDN;
export const IMNFlag = IMN;
export const INDFlag = IND;
export const IOTFlag = IOT;
export const IRLFlag = IRL;
export const IRNFlag = IRN;
export const IRQFlag = IRQ;
export const ISLFlag = ISL;
export const ISRFlag = ISR;
export const ITAFlag = ITA;
export const JAMFlag = JAM;
export const JEYFlag = JEY;
export const JORFlag = JOR;
export const JPNFlag = JPN;
export const KAZFlag = KAZ;
export const KENFlag = KEN;
export const KGZFlag = KGZ;
export const KHMFlag = KHM;
export const KIRFlag = KIR;
export const KNAFlag = KNA;
export const KORFlag = KOR;
export const KWTFlag = KWT;
export const LAOFlag = LAO;
export const LBNFlag = LBN;
export const LBRFlag = LBR;
export const LBYFlag = LBY;
export const LCAFlag = LCA;
export const LIEFlag = LIE;
export const LKAFlag = LKA;
export const LSOFlag = LSO;
export const LTUFlag = LTU;
export const LUXFlag = LUX;
export const LVAFlag = LVA;
export const MACFlag = MAC;
export const MAFFlag = MAF;
export const MARFlag = MAR;
export const MCOFlag = MCO;
export const MDAFlag = MDA;
export const MDGFlag = MDG;
export const MDVFlag = MDV;
export const MEXFlag = MEX;
export const MHLFlag = MHL;
export const MKDFlag = MKD;
export const MLIFlag = MLI;
export const MLTFlag = MLT;
export const MMRFlag = MMR;
export const MNEFlag = MNE;
export const MNGFlag = MNG;
export const MNPFlag = MNP;
export const MOZFlag = MOZ;
export const MRTFlag = MRT;
export const MSRFlag = MSR;
export const MTQFlag = MTQ;
export const MUSFlag = MUS;
export const MWIFlag = MWI;
export const MYSFlag = MYS;
export const MYTFlag = MYT;
export const NAMFlag = NAM;
export const NCLFlag = NCL;
export const NERFlag = NER;
export const NFKFlag = NFK;
export const NGAFlag = NGA;
export const NICFlag = NIC;
export const NIUFlag = NIU;
export const NLDFlag = NLD;
export const NORFlag = NOR;
export const NPLFlag = NPL;
export const NRUFlag = NRU;
export const NZLFlag = NZL;
export const OMNFlag = OMN;
export const PAKFlag = PAK;
export const PANFlag = PAN;
export const PCNFlag = PCN;
export const PERFlag = PER;
export const PHLFlag = PHL;
export const PLWFlag = PLW;
export const PNGFlag = PNG;
export const POLFlag = POL;
export const PRIFlag = PRI;
export const PRKFlag = PRK;
export const PRTFlag = PRT;
export const PRYFlag = PRY;
export const PSEFlag = PSE;
export const PYFFlag = PYF;
export const QATFlag = QAT;
export const REUFlag = REU;
export const ROUFlag = ROU;
export const RUSFlag = RUS;
export const RWAFlag = RWA;
export const SAUFlag = SAU;
export const SDNFlag = SDN;
export const SENFlag = SEN;
export const SGPFlag = SGP;
export const SGSFlag = SGS;
export const SHNFlag = SHN;
export const SJMFlag = SJM;
export const SLBFlag = SLB;
export const SLEFlag = SLE;
export const SLVFlag = SLV;
export const SMRFlag = SMR;
export const SOMFlag = SOM;
export const SPMFlag = SPM;
export const SRBFlag = SRB;
export const SSDFlag = SSD;
export const STPFlag = STP;
export const SURFlag = SUR;
export const SVKFlag = SVK;
export const SVNFlag = SVN;
export const SWEFlag = SWE;
export const SWZFlag = SWZ;
export const SYCFlag = SYC;
export const SYRFlag = SYR;
export const TCAFlag = TCA;
export const TCDFlag = TCD;
export const TGOFlag = TGO;
export const THAFlag = THA;
export const TJKFlag = TJK;
export const TKLFlag = TKL;
export const TKMFlag = TKM;
export const TLSFlag = TLS;
export const TONFlag = TON;
export const TTOFlag = TTO;
export const TUNFlag = TUN;
export const TURFlag = TUR;
export const TUVFlag = TUV;
export const TWNFlag = TWN;
export const TZAFlag = TZA;
export const UGAFlag = UGA;
export const UKRFlag = UKR;
export const URYFlag = URY;
export const USAFlag = USA;
export const UZBFlag = UZB;
export const VATFlag = VAT;
export const VCTFlag = VCT;
export const VENFlag = VEN;
export const VGBFlag = VGB;
export const VIRFlag = VIR;
export const VNMFlag = VNM;
export const VUTFlag = VUT;
export const WLFFlag = WLF;
export const WSMFlag = WSM;
export const XKXFlag = XKX;
export const YEMFlag = YEM;
export const ZAFFlag = ZAF;
export const ZMBFlag = ZMB;
export const ZWEFlag = ZWE;
